import { render } from "./StudentImportSchoolYearArea.vue?vue&type=template&id=1f8d3e18&scoped=true&ts=true"
import script from "./StudentImportSchoolYearArea.vue?vue&type=script&lang=ts"
export * from "./StudentImportSchoolYearArea.vue?vue&type=script&lang=ts"

import "./StudentImportSchoolYearArea.vue?vue&type=style&index=0&id=1f8d3e18&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8d3e18"]])

export default __exports__